var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.987 16.5.137.006c.72.064 1.3.631 1.367 1.356l.006.138c0 .822-.678 1.5-1.5 1.5a1.501 1.501 0 0 1-.145-2.993l.135-.007zm0-6 .137.006c.72.064 1.3.631 1.367 1.356l.006.138c0 .822-.678 1.5-1.5 1.5a1.501 1.501 0 0 1-.145-2.993l.135-.007zm0-6 .137.006c.72.064 1.3.631 1.367 1.356l.006.138c0 .822-.678 1.5-1.5 1.5a1.501 1.501 0 0 1-.145-2.993l.135-.007z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMoreVertical);
export default __webpack_public_path__ + "static/media/icons-more-vertical.6c00ad0386636a2b7c36b84e9516108b.svg";
export { ForwardRef as ReactComponent };